import { React, useEffect, useState } from 'react';
import { getImsmaIdAutocomplete } from 'api/FilterMapApi';
import { SelectComponent } from 'component/Select';

export const ImsmaIdFilter = (props) => {
  const [options, setOptions] = useState([]);

  const getTeamOptions = () => {
    getImsmaIdAutocomplete()
      .then((res) => {
        const resOptions = res.data.map((item) => ({
          value: item,
          label: item,
        }));

        setOptions(resOptions);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getTeamOptions();
  }, []);

  return (
    <div className="flex-column-group">
      <span>Sort by IMSMA Id</span>
      <SelectComponent
        className="full"
        value={props.imsmaIdFilter}
        options={options}
        handleSelect={(e) => {
          props.setImsmaIdFilter(e);
        }}
        isMulti
      />
    </div>
  );
};
